module.exports = __webpack_public_path__ + "img/bg-7.92c27c8a.webp";